import Tooltip from 'bootstrap/js/dist/tooltip';

const initTooltips = () => {
    // console.log("initTooltips running");

    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
        // console.log("found tooltip element:", el);
        new Tooltip(el);
    });
}

export default initTooltips;